import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Download, Image, FileText, Code } from "lucide-react";

const typeIcons = { image: Image, text: FileText, template: Code };

export default function AssetsPage() {
  const [assets, setAssets] = useState([]);

  useEffect(() => {
    api.get("/assets").then(r => setAssets(r.data)).catch(console.error);
  }, []);

  return (
    <div className="space-y-6 max-w-5xl" data-testid="assets-page">
      <div className="animate-fade-in-up">
        <h1 className="text-2xl sm:text-3xl font-semibold text-white/90 tracking-tight">Marketing Assets</h1>
        <p className="text-white/35 text-sm mt-1">Download brand resources for your campaigns</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 stagger">
        {assets.map((a) => {
          const Icon = typeIcons[a.type] || FileText;
          return (
            <div key={a.id} className="glass glass-hover rounded-2xl overflow-hidden group animate-fade-in-up" data-testid={`asset-card-${a.id}`}>
              {a.preview_url && (
                <div className="h-36 bg-white/[0.02] overflow-hidden">
                  <img src={a.preview_url} alt={a.title} className="w-full h-full object-cover opacity-60 group-hover:opacity-80 transition-opacity duration-300" loading="lazy" />
                </div>
              )}
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <Icon className="w-4 h-4 text-[#F7941D]" strokeWidth={1.5} />
                  <Badge variant="outline" className="text-[10px] border-white/[0.08] uppercase tracking-wider bg-white/[0.04] text-white/40">{a.type}</Badge>
                </div>
                <h3 className="font-medium text-sm text-white/80 mb-1">{a.title}</h3>
                <p className="text-xs text-white/30 mb-3 line-clamp-2">{a.description}</p>
                <button className="w-full glass glass-hover rounded-full py-2 text-xs text-white/50 hover:text-white/80 flex items-center justify-center gap-2 transition-all duration-300" data-testid={`download-${a.id}`}>
                  <Download className="w-3 h-3" />
                  Download
                </button>
              </div>
            </div>
          );
        })}
        {assets.length === 0 && (
          <div className="col-span-full text-center text-white/25 py-12">No assets available yet</div>
        )}
      </div>
    </div>
  );
}
